<template>
    <div class="upload-container">
        <div>
            <button :class="buttonClass" @click="chooseFile">
                <i :class="icon"></i>&nbsp;&nbsp;Choose file
            </button>
            <input type="file" ref="upload" :accept="accept" hidden @change="getFile" />
        </div>
        
        <span class="file-name">{{fileName}}</span>
    </div>

</template>

<script>
export default {
    name: 'mdb-file-upload',
    methods: {
        chooseFile() {
            this.$refs.upload.click();
        },
        getFile(e) {
            const file = e.target.files[0];
            this.file = file;
        }
    },
    computed: {
        fileName() {
            return this.file ? this.file.name : 'No file selected.'
        },
        file: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    props: {
        value: {
            type: File,
            default: null
        },
        accept: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: 'fas fa-upload'
        },
        buttonClass: {
            type: String,
            default: 'btn btn-secondary'
        }
    }
}
</script>

<style lang="scss" scoped src="./Style/file-upload.scss">

</style>